import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { Planet } from "../icons/Planet";
import { Signal } from "../icons/Signal";
import styles from "./LiveCountdown.module.css";
const formatTimeToStart = (remainingTime) => {
    if (remainingTime <= 0) {
        return t("player.countdown.startSoon");
    }
    const secondsInADay = 86400;
    const secondsInAnHour = 3600;
    const secondsInAMinute = 60;
    const days = Math.floor(remainingTime / secondsInADay);
    const remainingSecondsAfterDays = remainingTime % secondsInADay;
    const hours = Math.floor(remainingSecondsAfterDays / secondsInAnHour);
    const remainingSecondsAfterHours = remainingSecondsAfterDays % secondsInAnHour;
    const minutes = Math.floor(remainingSecondsAfterHours / secondsInAMinute);
    const secs = Math.floor(remainingSecondsAfterHours % secondsInAMinute);
    return t("player.countdown", {
        day: days,
        hour: hours,
        minute: minutes,
        sec: secs,
    });
};
export const LiveCountdown = ({ timeToStart, cover }) => {
    var _a;
    const [remainingTime, setRemainignTime] = useState(0);
    useEffect(() => {
        setRemainignTime(timeToStart);
        const interval = setInterval(() => {
            setRemainignTime((prevRemainingTime) => prevRemainingTime - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [timeToStart]);
    return (React.createElement("div", { className: styles.container, style: { backgroundImage: (_a = `url(${cover})`) !== null && _a !== void 0 ? _a : "" } },
        !cover && React.createElement(Planet, null),
        React.createElement("div", { className: styles.timeToStartContainer },
            React.createElement(Signal, null),
            React.createElement("span", { className: styles.typographyCountdown }, formatTimeToStart(remainingTime)))));
};
//# sourceMappingURL=index.js.map